<template>
  <div>
    <!-- START imperia toolbar -->
    <div class='i-toolbar clearfix'>
      <div class='i-toolbar-title'>
        <h1>{{LANG.savedSearchFilters}}</h1>
      </div>
      <div class='i-toolbar-btn-container i-btn-container-left'></div>
      <div class='i-toolbar-btn-container i-btn-container-right'></div>
    </div>
    <!--  END  imperia toolbar -->

    <!-- START panel view -->
    <div id='i-panelview-container'>
      <div class='i-panel-item ui-layout-center'>
        <div>
          <div class='low-deck'>
            <table ref='table2' class='filelist table'>
              <thead>
                <tr>
                  <th>{{LANG.name}}</th>
                  <th>{{LANG.source}}</th>
                  <th>{{LANG.queryMode}}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for='filter in filters' :key='filter.name'>
                  <td>{{filter.name}}</td>
                  <td class='capitalize'>{{ browserModeLabels[filter.type] || filter.type_label }}</td>
                  <td class='capitalize'>{{filter.iqlmode_label}}</td>
                  <td>
                    <button
                      @click.prevent.stop='() => onClickDelete(filter)'
                      class='i-button i-secondary-btn'>{{LANG.delete}}</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class='i-panel-item ui-layout-east hidden'></div>
    </div>
    <!--  END  panel view -->
    <i-modal :title="LANG.confirmation" v-model:show="showConfirmationModal">
      {{ LANG.confirmDeleteFilter }}<br><br>{{ filterToDelete.name }}
      <template #footer>
        <i-button variant="secondary" @click.prevent="showConfirmationModal=false">
          {{ LANG.cancel }}
        </i-button>
        <i-button variant="primary"
          @click.prevent="deleteFilter(filterToDelete); showConfirmationModal = false;">
          {{ LANG.delete }}
        </i-button>
      </template>
    </i-modal>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'vuex';
import fetchService from '@/utils/model/fetch_service';
import { showToast } from '@/utils/tools';
import { BrowserMode } from '@/store/modules/entity_browser/config';

export default defineComponent({
  name: 'SavedSearchFilters',
  created() {
    this.loadFilters();
  },
  data: () => ({
    filters: [],
    filterToDelete: Object,
    showConfirmationModal: false,
  }),
  computed: {
    ...mapState(['LANG']),
    browserModeLabels() {
      return {
        [BrowserMode.DOC]: 'Document Browser',
        [BrowserMode.MAM]: 'Media Management',
      };
    },
  },
  methods: {
    ...mapActions([]),
    // Data actions
    async loadFilters() {
      const data = await fetchService.GetData('docbrowser_get_saved_filters');

      if (data.error) {
        showToast(data.message, 1);
      } else if (Array.isArray(data.data)) {
        this.filters = data.data;
      }
    },
    onClickDelete(filter) {
      this.showConfirmationModal = true;
      this.filterToDelete = filter;
    },
    async deleteFilter(filter) {
      const collection = 'docbrowser_filters_delete';
      const id = filter.filter_id;
      const params = { '@path': String(id) };

      const data = await fetchService.GetData(collection, params);

      if (data.error) {
        showToast(data.message, 1);
      } else {
        this.filters = this.filters.filter((v) => v.filter_id !== id); // eslint-disable-line
      }
    },
  },
});
</script>

<style scoped lang='scss'>
::v-deep .ui-layout-resizer {
    display: none !important;
  }

.capitalize {
  text-transform: capitalize;
}

.i-panel-item {
  width: 100% !important;
  height: 100%;
  overflow: hidden;

  > :first-child {
    height: inherit;
  }
}

tr >:last-child {
  text-align: right;
  padding-right: 15px;
}

table {
  margin-bottom: unset;

  thead {
    background-color: #fff;
    color: #191919;
    position: sticky;
    top: 0px;
    white-space: nowrap;
    box-shadow: 0px 1px #cfcfcf;
    z-index: 10;
  }
}

table.filelist tr:hover {
  background-color: $ibutton-bg-hover-color-light;
  color: $blue;
}

.low-deck {
  height: calc(100% - 42px);
  overflow: auto;
}
</style>
